import { useState, createContext, useContext } from "react";

const SampleContext = createContext();

export function SampleProvider(props) {
  const [wasatchSample, setWasatchSample] = useState({
    presumed: "",
    presumedSubDescription: "",
    colour: [],
    texture: [],
    bulk: [],
    trace: [],
    geometry: {},
  });

  const [device, setDevice] = useState();

  const setCalibrationDevice = (calibrationDevice) => {
    setDevice(calibrationDevice);
  };

  const setPresumedSubstance = (substance, description) => {
    setWasatchSample({
      ...wasatchSample,
      presumed: substance,
      presumedSubDescription: description,
    });
  };

  const setColour = (colour) => {
    setWasatchSample({ ...wasatchSample, colour: colour });
  };

  const setTexture = (texture) => {
    setWasatchSample({ ...wasatchSample, texture: texture });
  };

  const setGeometry = (location) => {
    console.log("Setting device location:", location);
    setWasatchSample({ ...wasatchSample, geometry: location });
  };

  const initWasatchBulk = (sequences) => {
    setWasatchSample({ ...wasatchSample, bulk: sequences });
  };

  const initWasatchTrace = (sequences) => {
    setWasatchSample({ ...wasatchSample, trace: sequences });
  };

  const initWasatchBackground = (sequences) => {
    setWasatchSample({ ...wasatchSample, background: sequences });
  };

  const resetSampleData = () => {
    setWasatchSample({
      presumed: "",
      presumedSubDescription: "",
      colour: [],
      bulk: [],
      trace: [],
      texture: [],
      geometry: {},
    });
  };

  return (
    <SampleContext.Provider
      value={{
        wasatchSample,
        device,
        setCalibrationDevice,
        setPresumedSubstance,
        setColour,
        setTexture,
        setGeometry,
        initWasatchBulk,
        initWasatchTrace,
        initWasatchBackground,
        resetSampleData,
      }}
    >
      {props.children}
    </SampleContext.Provider>
  );
}

export const useSampleContext = () => {
  const {
    wasatchSample,
    device,
    setCalibrationDevice,
    setPresumedSubstance,
    setColour,
    setTexture,
    setGeometry,
    initWasatchBulk,
    initWasatchTrace,
    initWasatchBackground,
    resetSampleData,
  } = useContext(SampleContext);
  return {
    wasatchSample,
    device,
    setCalibrationDevice,
    setPresumedSubstance,
    setColour,
    setTexture,
    setGeometry,
    initWasatchBulk,
    initWasatchTrace,
    initWasatchBackground,
    resetSampleData,
  };
};
